import service from "../plugins/service"

export const getServiceData = () => {
  return service({
    url: '/data/service',
    method: 'GET'
  })
}

export const getMonitorData = (areaCode, dataType) => {
  return service({
    url: '/data/monitor',
    method: 'get',
    params: {
      areaCode,
      type: dataType
    }
  })
}

export const getWarnData =  (id, total) => {
  return service({
    url: '/data/warning',
    method: 'get',
    params: {
      id,
      total,
    }
  })
}